export function getSearchText(state) {
    return state.searchText;
}

export function getSearchTextVisibility(state){
    return state.isSearchTextVisible
}

export function getSearchTextFilled(state) {
    return state.searchText !== "";
}

export function getSelectedFilters(state) {
    return state.selectedFilters;
}

export function getFiltersListValues(state) {
    return state.filtersListValues;
}

export function getFooterStatus(state) {
    return state.showFooter;
}

export function getSearchResults(state) {
    return state.searchResults;
}

export function getContentTypesCount(state) {
    const initialContentTypes = {
        "Sentencia procedimiento mercantil": 0,
        "Sentencia en audiencia oral": 0,
        "Conceptos jurídicos": 0,
        "Temas y problemas": 0,
    };

    const contentTypes =
        state.searchResults?.data?.aggregations?.contentType?.buckets;

    if (!contentTypes) {
        return initialContentTypes;
    }

    const reduceContentTypes = contentTypes.reduce(
        (acc, cT) => ({ ...acc, [cT.key]: cT.doc_count }),
        initialContentTypes
    );

    return reduceContentTypes;
}

export function getDateResults(state) {
    return state.dateResults;
}

export function getSavedResults(state) {
    return state.savedResults;
}

export function getSavedContentTypesCount(state) {
    const initialContentTypes = {
        "Sentencia procedimiento mercantil": 0,
        "Sentencia en audiencia oral": 0,
        "Conceptos jurídicos": 0,
        "Temas y problemas": 0,
    };

    const savedResults = getSavedResults(state); // Obtener los resultados guardados

    if (!savedResults || savedResults.length === 0) {
        return initialContentTypes; // Si no hay resultados guardados, retorna los valores iniciales
    }

    const reduceContentTypes = savedResults.reduce((acc, result) => {
        const tipoContenido = result.informacion?.tipo_contenido;

        if (tipoContenido && acc.hasOwnProperty(tipoContenido)) {
            // Si el tipo de contenido existe en el mapeo inicial, incrementa el contador
            acc[tipoContenido] += 1;
        }

        return acc;
    }, initialContentTypes);

    return reduceContentTypes;
}

export function getSavedBorradores(state) {
    if (state !== undefined) {
        return state.savedBorradores;
    }
}

export function getDocumentSearchText(state) {
    return state.searchDocumentText;
}

export function getLoadingResults(state) {
    return state.loadingResults;
}

export function getSearchTrigger(state) {
    return state.searchTrigger;
}

export function getSortType(state) {
    return state.sortType;
}

export function getResultsViewPage(state) {
    return state.resultsViewPage;
}

export function getFiltersEraser(state) {
    return state.savedFiltersEraser;
}

export function getTabSelected(state) {
    if (state !== undefined) {
        return state.tabSelected;
    } else {
        return 1;
    }
}
